<template>
  <div class="reserve">
    <div class="back">
      <img src="@/assets/img/back.png" alt @click="backHandler" />
    </div>
    <div class="content">
      <div class="has-data">
        <!-- <div class="top" v-show="units !== null && reservations.length !== 0"> -->
        <div class="top" v-if="!noClass">
          <h3>我的预约</h3>
          <div class="btn" @click="reserveHandler('')">预约课程</div>
        </div>
        <div class="list">
          <div class="list-common doing-list"  v-if="state['in-progress'].length !== 0">
            <h4>进行中</h4>
            <ul class="list">
              <li v-for="(item, index) in state['in-progress']" :key="index">
                <div class="li-top">
                  <p class="day">{{lockShowDay(item)}}</p>
                  <p class="time">{{lockShowTime(item)}}</p>
                </div>
                <div class="li-bottom">
                  <p @click="backClassHandler(item)">返回课堂</p>
                </div>
              </li>
            </ul>
          </div>
          <div class="list-common reserve-list"  v-if="state['not-started'].length !== 0">
            <h4>未开始</h4>
            <ul class="list">
              <li v-for="(item, index) in state['not-started']" :key="index">
                <div class="li-top">
                  <p class="day">{{lockShowDay(item)}}</p>
                  <p class="time">{{lockShowTime(item)}}</p>
                </div>
                <div class="li-bottom li-bottom2" v-show="showBottom(item.start) === 3">
                  <!-- <p @click="changeHandler(item._id, item.unitId)">改期</p> -->
                  <p @click="cancelHandler(item._id)">取消</p>
                </div>
                <div class="li-bottom li-bottom2" v-show="showBottom(item.start) === 4">
                  <p @click="inClassHandler(item)">进入课堂</p>
                </div>
                <div class="li-bottom li-bottom1" v-show="showBottom(item.start) === 1">即将开始</div>
                <div class="li-bottom li-bottom1" v-show="showBottom(item.start) === 2">距离预约时间小于12小时，不可取消</div>
              </li>
            </ul>
          </div>
          <div class="list-common history-list" v-if="state['completedOrMissed'].length !== 0">
            <h4>预约历史</h4>
            <ul class="reserve-his">
              <li v-for="(item, index) in state['completedOrMissed']" :key="index">
                <p class="his-time">{{lockShowDay(item)}} {{lockShowTime(item)}}</p>
                <div class="his-status">
                  <p v-if="item.newState === 'missed'">已错过</p>
                  <p v-else class="p2">已上完</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- <div class="empty-data"></div> -->

      <!-- <ul class="list" v-if="reservations.length !== 0">
        <li v-for="(item, index) in reservations" :key="index">
          <div class="li-top">
            <p class="day">{{lockShowDay(item)}}</p>
            <p class="time">{{lockShowTime(item)}}</p>
          </div>
          <div class="li-bottom li-bottom2" v-show="showBottom(item.start) === 3">
            <p @click="changeHandler(item._id, item.unitId)">改期</p>
            <p @click="cancelHandler(item._id)">取消</p>
          </div>
          <div class="li-bottom li-bottom1" v-show="showBottom(item.start) === 1">即将开始</div>
          <div class="li-bottom li-bottom1" v-show="showBottom(item.start) === 2">距离预约时间小于12小时，不可改期或取消</div>
        </li>
      </ul>
      <div class="no-class" v-else-if="units !== null && units.length === 0" >
        <img src="@/assets/images/reserve-star.png" alt="" />
        <p class="p1">抱歉，您的课时已用光，无法预约课程</p>
      </div>-->
      <div class="no-class" v-if="noClass" >
        <img src="@/assets/images/reserve-star.png" alt="" />
        <p class="p1">您还没有预约课程</p>
        <p class="p2" @click="reserveHandler('')">预约课程</p>
      </div>
    </div>
    <ReserveDialog
      ref="reserveDialog"
      v-show="isShowReserveDialog"
      :packageId="packageId"
      :packageInfo="packageInfo"
      :deleteReservationId="deleteReservationId"
      :nowUnitId="nowUnitId"
      :units="units"
      :reservationLists="reservations"
      :historyUnit="historyUnit"
      @close="close"
      @getReservations="getReservations"
    />
    <ReserveIntroDialog
      v-show="isShowReserveIntroDialog"
      :packageId="packageId"
      :packageInfo="packageInfo"
      :deleteReservationId="deleteReservationId"
      :nowUnitId="nowUnitId"
      :units="units"
      @close="close"
      @getReservations="getReservations"
    />
    <ReserveSuccDialog
      v-show="isShowReserveSuccDialog"
      dialogType="alert"
      massage="你的预约次数已到达上限"
      @closeSuccHandler="close"
    />
    <ImConfirm
      v-show="isShowImcomfirm"
      :massage="confirmMsg"
      @okClick="confirmOkHanlder"
      @noClick="confirmClose"
    />
    <!-- 提示框 -->
    <MessageTime
      v-show="isShowMessageTime"
      :message="messageTimeText"
    />
  </div>
</template>

<script>
import ReserveDialog from '../components/reserveDialog'
import ReserveIntroDialog from '../components/reserveIntroDialog'
import ReserveSuccDialog from '../components/reserveSuccessDialog'
import ImConfirm from '@/components/imConfirm'
import MessageTime from "@/components/messageTime"
export default {
  data () {
    return {
      isShowReserveDialog: false,
      isShowReserveSuccDialog: false,
      isShowReserveIntroDialog: false,
      reservations: [],
      packageId:"",
      reservationId:"",
      unitId:"",
      nowUnitId:"",
      packageInfo: {},
      units: null,
      deleteReservationId: '',
      serverDate:'',
      timer: null,
      confirmMsg:'',
      isShowImcomfirm: false,
      confirmOk: 0,
      historyUnit: [],
      isShowMessageTime: false,
      messageTimeText: '',
      unitStats: "",
      state:{
        "completedOrMissed": [],
        "not-started": [],
        "in-progress": []
      }
    }
  },
  components: {
    ReserveDialog,
    ReserveSuccDialog,
    ReserveIntroDialog,
    ImConfirm,
    MessageTime
  },
  computed: {
    noClass() {
      if(this.state['completedOrMissed'].length === 0
      && this.state['not-started'].length === 0
      && this.state['in-progress'].length === 0){
        return true;
      }
      return false;
    }
  },
  mounted (){
    //获取所有预约课程
    this.getReservations();
    this.timer = setInterval(() => {
      this.getReservations();
    }, 60000);
    //获取课程包名字
    this.getPackageName();
  },
  methods:{
    inClassHandler(item) {
      window.location.href = `/student?id=${item._id}&unitStats=${this.unitStats}`;
    },
    backClassHandler(item) {
      window.location.href = `/student?id=${item._id}&unitStats=${this.unitStats}`;
    },
    compare(prop) {
      return function (obj1, obj2) {
        var val1 = new Date(obj1[prop]).getTime();
        var val2 =  new Date(obj2[prop]).getTime();
        if (val1 < val2) {
            return -1;
        } else if (val1 > val2) {
            return 1;
        } else {
            return 0;
        }
      }
    },
    showBottom(t) {
      let now = new Date(this.serverDate);
      let start = new Date(t);
      let date12 = 12*60*60*1000;
      let date1 = 1*60*60*1000;
      let date10m = 10*60*1000;
      //课程开始前十分钟和后十分钟，显示进入课堂。
      if(Math.abs(start - now) < date10m){
        return 4;
      }
      //距离开课时间小于1小时，显示“即将开始”；
      if(start - now > 0 && start - now < date1){
        return 1;
      }
      //距离开课时间小于12小时且大于等于1小时，显示“距离预约时间小于12小时，不可改期或取消”；
      if(start - now > 0 && start - now < date12){
        return 2;
      }
      //距离开课时间大于等于12小时，显示改期和取消按钮。
      if(start - now > 0 && start - now >= date12){
        return 3;
      }
    },
    getReservations (){
      this.packageId = this.$route.query.packageId;
      this.unitStats = this.$route.query.unitStats;
      this.axios
        .get(`/im/self/packages/${this.packageId}/reservations`)
        .then(res => {
          //服务器时间
          this.serverDate = res.headers.date;
          this.reservations = res.data.reservations;
        })
        .catch(error => {
          console.log(error);
        });

      this.axios.get(`/im/self/packages/${this.packageId}/reservations?all=true`)
        .then(res => {
          //服务器时间
          this.serverDate = res.headers.date;
          let data = res.data.reservations.sort(this.compare("start"));
          // let data = res.data.reservations;
          this.state = {
            "completedOrMissed": [],
            "not-started": [],
            "in-progress": []
          }
          var close = new Date(new Date(this.serverDate) - 10 * 60000); // 10-minute delay

          for (var r of data) {
            var trackedState = r.tracked && r.tracked.state || 'unknown';
            let start = new Date(r.start);
            let end = new Date(r.end);
            switch(trackedState) {
              case 'completed':
                r['newState'] = "completed";
                this.state.completedOrMissed.push(r);
                break;
              case 'not-started':
                if(close > start){
                  r['newState'] = "missed";
                  // 新需求 停止显示错过的 2021.6,28  zyc 数据不再加入 注释
                  //this.state.completedOrMissed.push(r);

                }else{
                  this.state["not-started"].push(r);
                }
                break;
              case 'in-progress':
                if(close > end){
                  r['newState'] = "completed";
                  this.state.completedOrMissed.push(r);
                }else{
                  this.state["in-progress"].push(r);
                }
                break;
              default:;
            }
          }
          console.log(this.state)
        })
        .catch(error => {
          console.log(error);
        });

      //判断是否可预约，获取可以预约的units
      this.axios
        .get(`/im/self/packages/${this.packageId}/nextunits`)
        .then(res => {
          this.units = res.data.units;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getPackageName (){
      this.axios
        .get(`/im/self/packages/${this.packageId}`)
        .then(res => {
          this.packageInfo = res.data.package;
          this.historyUnit = res.data.history;
          this.nextUnit = res.data.next;
        })
        .catch(error => {
          console.log(error);
        });
    },
    lockShowDay(unit) {
      if (unit.start) {
        let startDateO = new Date(unit.start);
        var weeks = ["日", "一", "二", "三", "四", "五", "六"];
        let startDate = `${startDateO.getMonth() +
          1}月${startDateO.getDate()}日 周${weeks[startDateO.getDay()]}`;
        return startDate;
      }
    },
    toDouble(n) {
      return n < 10 ? "0" + n : n;
    },
    lockShowTime(unit) {
      if (unit.start) {
        let startDateO = new Date(unit.start);
        let amOpm = startDateO.getHours() > 12? "下午" : "上午";
        let startDate = `${amOpm} ${this.toDouble(
          startDateO.getHours()
        )}:${this.toDouble(startDateO.getMinutes())}`;
        return startDate;
      }
    },
    changeHandler (id, unitId){
      this.isShowImcomfirm = true;
      this.confirmMsg = "确定修改预约日期吗？";
      this.nowUnitId = unitId;
      this.reservationId = id;
      this.confirmOk = 1;
    },
    confirmOkHanlder () {
      if(this.confirmOk === 1){//改期
        this.reserveHandler(this.reservationId, this.nowUnitId);
        this.$refs.reserveDialog.reservationListsChange(this.reservationId);
      }else if(this.confirmOk === 2){
        this.cancelOk ();
      }
    },
    cancelHandler (id){
      this.isShowImcomfirm = true;
      this.confirmMsg = "确定取消已预约课程吗？";
      this.reservationId = id;
      this.confirmOk = 2;
    },
    cancelOk () {
      this.axios
        .delete(`/im/reservations/${this.reservationId}`)
        .then(res => {
          //更新所有预约课程
          this.isShowMessageTime = true;
          this.messageTimeText = '成功取消预约';
          let timer = setTimeout(() => {
            clearTimeout(timer);
            this.isShowMessageTime = false;
            // fn && fn();
          }, 500);
          this.getReservations();
        })
        .catch(error => {
          console.log(error);
        });
    },
    backHandler () {
      this.$router.push({
        path: '/',
        query: { packageId: this.packageId }
      });
    },
    close (){
      this.isShowReserveDialog = false;
      this.isShowReserveSuccDialog = false;
      this.isShowReserveIntroDialog = false;
    },
    confirmClose () {
      this.isShowImcomfirm = false;
    },
    reserveHandler (id="",unitId="") {
      //在获取可预约unit请求之前，无法点击预约按钮显示预约页面
      if(this.units === null){
        return;
      }
      if(this.packageInfo.trial === true){//试听课
        //预约，非改期
        if(this.units.length === 0 && id === ''){
          this.isShowReserveSuccDialog = true;
          return;
        }
        this.isShowReserveIntroDialog = true;
        //改期ID为空
        this.deleteReservationId = id;
        this.nowUnitId = unitId;
      }else{//正式课
        //改期=>不需要考虑unit，只需要有unitid
        //预约=>没有可预约的unit，提示无法预约
        //一个星期最多只能预约或者上过一节课, 非改期
        
        // 预约总课程数上限 = 暂时一次预约2周后台和前端控制X每周约课数 = 
        if(this.isCanReserve() >= 12 && id === '') {// 原4节课上限2X2 修改为12节课 2X6
          this.isShowReserveSuccDialog = true;
          return;
        }
        //预约，非改期
        if(this.units.length === 0 && id === ''){
          this.isShowReserveSuccDialog = true;
          return;
        }
        //改期ID为空
        this.deleteReservationId = id;
        this.nowUnitId = unitId;
        //显示预约页面
        this.isShowReserveDialog = true;
      }
    },
    isCanReserve () {
      let count = 0;
      for(let i = 0; i < this.historyUnit.length; i++){
        if(this.isSameWeek(this.historyUnit[i].start, this.serverDate)){
          count ++;
        }
      }
      return count + this.reservations.length;
    },
    isSameWeek (old, now) {
      var oneDayTime = 1000*60*60*24;
      var old_count =parseInt(new Date(old).getTime()/oneDayTime);
      var now_other =parseInt(new Date(now).getTime()/oneDayTime);
      return parseInt((old_count+4)/7) == parseInt((now_other+4)/7);
    }
  },
  destroyed() {
    clearInterval(this.timer);
  }
}
</script>

<style lang="stylus" scoped>
wh($w = 100%, $h = 100%){
  width: $w;
  height: $h;
}
flex2Center(){
  display: flex;
  align-items: center;
  justify-content: center;
}
.reserve{
  width: 100%;
  height: 100%;
  .back{
    padding: 20px 50px;
    transition: all .5s;
    img{
      wh(46px, 34px)
      cursor: pointer;
      &:hover{
        transform: scale(1.2);
      }
    }
  }
  .content{
    width: 840px;
    margin: 0 auto;
    .has-data{
      .top{
        display: flex;
        justify-content: space-between;
        color: #FF9E23;
        font-size: 20px;
        h3{
          padding-left: 20px;
          font-size: 26px;
        }
        .btn{
          wh(150px, 45px);
          color: #fff;
          border-radius: 40px;
          background-image: linear-gradient(-119deg, #FFD63C 0%, #FDAC1C 96%);
          flex2Center()
          margin-right: 30px;
          cursor: pointer;
        }
      }
      .list{
        .list-common{
          h4{
            color: #404040;
            font-size: 22px;
            display: flex;
            align-items: center;
            margin: 30px 0 0;
            &:before{
              content: "";
              display: inline-block;
              width: 10px;
              height: 10px;
              background: #6ED16E;
              border-radius: 50%;
              margin-right: 10px;
              margin-top: -3px;
            }
          }
          .list{
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            li{
              wh(400px, 135px);
              background: #FFFDF5;
              border: 1px solid #6ED16E;
              border-radius: 10px;
              list-style: none;
              margin: 15px 0;
              .li-top{
                wh(100%, 80px);
                display: flex;
                p{
                  wh(50%, 100%)
                  font-size: 22px;
                  color: #464646;
                  text-align: center;
                  flex2Center();
                  padding-left: 40px;
                  position:relative;
                }
                .day{
                  padding-left: 40px;
                  &:before{
                    content: "";
                    wh(24px, 24px)
                    background: url('~@/assets/images/time2.png') no-repeat;
                    background-size: 100% 100%;
                    position:absolute;
                    top: 28px;
                    left: 20px;
                  }
                }
                .time{
                  &:before{
                    content: "";
                    wh(24px, 24px)
                    background: url('~@/assets/images/clock2.png') no-repeat;
                    background-size: 100% 100%;
                    position:absolute;
                    top: 28px;
                    left: 35px;
                  }
                }
              }
              .li-bottom{
                wh(100%, 55px);
                color: #414141;
                border-radius: 0px 0px 10px 10px;
                flex2Center();
                background: #6ED16E;
                font-size: 18px;
                p{
                  width:130px;
                  height:34px;
                  background:rgba(255,255,255,1);
                  border-radius:17px;
                  flex2Center();
                  // margin: 0 20px;
                  cursor: pointer;
                }
              }
              .li-bottom1{
                background: #FFB04B;
                cursor: pointer;
              }
              .li-bottom2{
                background: #FFE188;
                p{
                  wh(100px, 35px)
                  background: #FFFFFF;
                  border-radius: 18px;
                  font-size: 18px;
                  flex2Center()
                  margin: 0 20px;
                  cursor: pointer;
                }
              }
            }
          }
        }
        .reserve-list{
          h4{
            &:before{
              background: #FFCF40;
            }
          }
          .list{
            li{
              background: #FFFDF5;
              border: 1px solid #FFCF40;
              .li-top{
                .day{
                  &:before{
                    background: url('~@/assets/images/time3.png') no-repeat;
                    background-size: 100% 100%;
                  }
                }
                .time{
                  &:before{
                    background: url('~@/assets/images/clock3.png') no-repeat;
                    background-size: 100% 100%;
                  }
                }
              }
              .li-bottom{
                background: #FFCF40;
              }
            }
          }
        }
        .history-list{
          h4{
            &:before{
              background: #FC8A27;
            }
          }
          .reserve-his{
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            padding-bottom: 100px;
            li{
              wh(400px, 70px);
              list-style: none;
              display: flex;
              flex-wrap: wrap;
              align-items: center;
              justify-content: space-between;
              border-bottom: 1px solid #E7E4CA;
              .his-time{
                color: #4E4E4E;
                font-size: 18px;
              }
              .his-status{
                p{
                  width:80px;
                  height:24px;
                  background:rgba(187,186,180,1);
                  border-radius:12px;
                  color: #fff;
                  display: flex;
                  align-items: center;
                  font-size: 14px;
                  &:before{
                    content: "";
                    display: inline-block;
                    wh(18px, 18px);
                    background: url("~@/assets/images/cry.png") no-repeat;
                    background-size: 100% 100%;
                    margin: 0 6px 0 3px;
                  }
                }
                .p2{
                  background: #51C351;
                  &:before{
                    background: url("~@/assets/images/smile.png") no-repeat;
                    background-size: 100% 100%;
                  }
                }
              }

            }
          }
        }
      }
      // .list{
      //   .doing-list{

      //   }
      //   display: flex;
      //   flex-wrap: wrap;
      //   justify-content: space-between;
      //   li{
      //     wh(400px, 135px);
      //     background: #FFFDF5;
      //     border: 1px solid #FF963B;
      //     border-radius: 10px;
      //     list-style: none;
      //     margin: 15px 0;
      //     .li-top{
      //       wh(100%, 80px);
      //       display: flex;
      //       p{
      //         wh(50%, 100%)
      //         font-size: 22px;
      //         color: #787878;
      //         text-align: center;
      //         flex2Center();
      //         padding-left: 40px;
      //         position:relative;
      //       }
      //       .day{
      //         padding-left: 40px;
      //         &:before{
      //           content: "";
      //           wh(24px, 24px)
      //           background: url('~@/assets/images/day.png') no-repeat;
      //           background-size: 100% 100%;
      //           position:absolute;
      //           top: 28px;
      //           left: 25px;
      //         }
      //       }
      //       .time{
      //         &:before{
      //           content: "";
      //           wh(24px, 24px)
      //           background: url('~@/assets/images/time.png') no-repeat;
      //           background-size: 100% 100%;
      //           position:absolute;
      //           top: 28px;
      //           left: 35px;
      //         }
      //       }
      //     }
      //     .li-bottom{
      //       wh(100%, 55px);
      //       color: #fff;
      //       border-radius: 0px 0px 10px 10px;
      //       flex2Center();
      //       font-size: 18px;
      //     }
      //     .li-bottom1{
      //       background: #FFB04B;
      //       cursor: pointer;
      //     }
      //     .li-bottom2{
      //       background: #FFE188;
      //       p{
      //         wh(100px, 35px)
      //         background: #FFFFFF;
      //         border-radius: 18px;
      //         font-size: 18px;
      //         color: #FF9E23;
      //         flex2Center()
      //         margin: 0 20px;
      //         cursor: pointer;
      //       }
      //     }
      //   }
      // }
    }

    .no-class{
      color: #908e8a;
      font-size: 22px;
      text-align: center;
      padding: 100px 50px;
      img{
        width: 160px;
        margin: 0 auto;
      }
      .p1{
        color: #333333;
        margin: 25px 0 50px;
      }
      .p2{
        width:173px;
        height:48px;
        background:linear-gradient(119deg,rgba(255,214,60,1) 0%,rgba(253,172,28,1) 100%);
        border-radius:24px;
        font-size:22px;
        font-weight:500;
        color:rgba(255,255,255,1);
        line-height:48px;
        margin: 0 auto;
        cursor: pointer;
      }
    }

  }
}
</style>
